import {
  ROUTE_SEO_CITY_APP,
  ROUTE_SEO_DIRECTORY_LANDMARK,
  ROUTE_SEO_DIRECTORY_NAMED_PLACE,
  ROUTE_SEO_DIRECTORY_SEASIDE_RESORT,
  ROUTE_SEO_DIRECTORY_SKI_RESORT,
  ROUTE_SEO_ITINERARY,
  ROUTE_SEO_ITINERARY_MODE,
  ROUTE_SEO_LANDMARK,
  ROUTE_SEO_NAMED_PLACE
} from '../../routes'
import { selectFirstAddress } from '../../store/address/address.selectors'
import {
  getPoiAverageNote,
  getPoiMaxNote,
  getPoiNumberOfReviews,
  getPoiRubricId
} from '../../store/geoentity/geoentity.accessors'
import {
  selectCurrentGeoentity,
  selectCurrentGeoentityRubricId,
  selectFirstGeoentity,
  selectFirstGeoentitySatisfying
} from '../../store/geoentity/geoentity.selectors'
import {
  isAGeoentityRoute,
  isGeoentityOnItineraryRoute,
  isLayerResponseRoute,
  isSearchOnItineraryRoute,
  isZoneRoute,
  selectCurrentHistoryRoute,
  selectCurrentHistoryRouteParams,
  selectIsASearchOnItineraryPage,
  selectIsASearchPage,
  selectIsItineraryUniverse,
  selectIsPlacesUniverse,
  selectIsSearchPage,
  selectIsSeoCityActivityPage,
  selectIsSeoCityAppPage,
  selectIsToolsComputeRadiusPage
} from '../../store/history/history.selectors'
import { selectCurrentMode } from '../../store/itinerary/itinerary.selectors'
import { selectHasRoadbook } from '../../store/itinerary/roadbook.selectors'
import { selectCurrentItineraryRouteDistance } from '../../store/itinerary/routes.selectors'
import { CONFIG_TYPES } from '../../store/poiassets/poiassets.constants'
import {
  findCategoryForItem,
  findCategoryIdForApp,
  selectGeoentityTypeDataForSearch
} from '../../store/poiassets/poiassets.selectors'
import { selectSearchParameters } from '../../store/search/search.selectors'
import { selectComputeRadius } from '../../store/tools/tools.selectors'
import { isEmpty } from '../../utils/lang'
import { selectArrivalStep, selectDepartureStep, selectStopSteps } from '../itinerary/steps/steps.selectors'
import { PARAM_REDIRECT, REDIRECT_QRCODE } from '../router/queryParameters.constants'
import { SUGGEST_FROM_VALUES } from '../suggest/suggest.constants'
import { RI_AFFICHAGE_ITI } from './analytics.tagids.constants'
import {
  getItinerariesActiveSort,
  getItinerariesParsedDetailsObj,
  getItineraryPoiTypesObj,
  getNumberOfDisplayedItinerariesObj,
  getQidObj,
  getStcLocaliteByGeocodeLevel,
  getTagLocaleFromRoute
} from './analyticsUtils'
import {
  NUMBER_OF_DISPLAYED_ROUTES_RESULTS,
  POI_ARRIVAL_TYPE,
  POI_DEPARTURE_TYPE,
  QID,
  ROUTE_RESULTS_ACTIVE_SORT,
  ROUTE_RESULTS_DURATIONS,
  ROUTE_RESULTS_LABELS,
  ROUTE_RESULTS_LENGTHS,
  ROUTE_RESULTS_PRICES
} from './ClickTagsService'
import {
  PAGE_PARAM_F3,
  PAGE_PARAM_MV,
  PAGE_PARAM_NAME,
  PAGE_PARAM_STC,
  PAGE_PARAM_X10,
  PAGE_PARAM_X11,
  PAGE_PARAM_X13,
  PAGE_PARAM_X15,
  PAGE_PARAM_X17,
  PAGE_PARAM_X3,
  PAGE_PARAM_X4,
  PAGE_PARAM_X5,
  PAGE_PARAM_X6,
  PAGE_PARAM_X7,
  PAGE_PARAM_X9
} from './pageTags.constants'
import { selectVariantForAbTestId } from '../../store/abtest/abtest.selectors'
import { PAGE_TAG } from './PageTagsService'

const getRedirection = query => {
  const qrcode = query?.get(PARAM_REDIRECT) === REDIRECT_QRCODE
  if (qrcode)
    return {
      Redirection: 'Vers_mobile_par_QRcode'
    }
  return {}
}

const stcResolverForItineraryUniverse = (store, pageTag, query) => {
  const [stc_codealler, stc_coderetour] = [selectDepartureStep(store), selectArrivalStep(store)].map(
    ({ towncode, countryCode }) => `${towncode}/${countryCode}`
  )
  const TypeObj = [ROUTE_SEO_ITINERARY, ROUTE_SEO_ITINERARY_MODE].includes(selectCurrentHistoryRoute(store))
    ? { Type: 'Page_LandingItineraire_Avril_2025' }
    : {}

  const CustomObj = ['ReponseItineraire', 'ReponseItineraireChoix'].includes(pageTag?.name)
    ? {
        tag_id: RI_AFFICHAGE_ITI,
        nombre_resultats: getNumberOfDisplayedItinerariesObj({ store })[NUMBER_OF_DISPLAYED_ROUTES_RESULTS],
        type_depart: getItineraryPoiTypesObj({ store })[POI_DEPARTURE_TYPE],
        type_arrivee: getItineraryPoiTypesObj({ store })[POI_ARRIVAL_TYPE],
        libelle_resultats: getItinerariesParsedDetailsObj({ store })[ROUTE_RESULTS_LABELS],
        tarif_resultats: getItinerariesParsedDetailsObj({ store })[ROUTE_RESULTS_PRICES],
        duree_resultats: getItinerariesParsedDetailsObj({ store })[ROUTE_RESULTS_DURATIONS],
        distance_resultats: getItinerariesParsedDetailsObj({ store })[ROUTE_RESULTS_LENGTHS],
        id_recherche_iti: getQidObj({ store })[QID],
        tri_resultats: getItinerariesActiveSort({ store })[ROUTE_RESULTS_ACTIVE_SORT]
      }
    : {}

  return {
    ...getRedirection(query),
    stc_codealler,
    stc_coderetour,
    ...TypeObj,
    ...CustomObj,
    ...(pageTag?.tag_id ? { tag_id: pageTag?.tag_id } : {})
  }
}

const stcResolver = (store, pageTag, query) => {
  if (selectIsItineraryUniverse(store)) {
    return stcResolverForItineraryUniverse(store, pageTag, query)
  }

  const route = selectCurrentHistoryRoute(store)
  const firstAddress = selectFirstAddress(store)
  const { departmentCode, regionCode, countryCode, geocode_level } = firstAddress

  if (isLayerResponseRoute(route)) {
    return {
      type: 'Page_Reponse_Juin_2023',
      localite: getStcLocaliteByGeocodeLevel(geocode_level),
      departement: departmentCode || '',
      region: regionCode || '',
      pays: countryCode
    }
  }

  if (isZoneRoute(route)) {
    return {
      type: 'Page_plan_Janvier_2023',
      localite: getTagLocaleFromRoute(route),
      departement: departmentCode || '',
      region: regionCode || '',
      pays: countryCode
    }
  }

  if (route === ROUTE_SEO_CITY_APP) {
    return {
      type: 'Page_LandingActiviteAppVille_Juillet_2023',
      localite: 'Ville',
      departement: departmentCode || '',
      region: regionCode || '',
      pays: countryCode
    }
  }

  const isLandmark = route === ROUTE_SEO_LANDMARK
  const isNamedPlace = route === ROUTE_SEO_NAMED_PLACE
  if (isLandmark || isNamedPlace) {
    const { name, named_place } = firstAddress
    return {
      type: 'Page_destination_touristique_avril_2025',
      lieu: isLandmark ? name : named_place,
      localite: isLandmark ? 'lieu' : 'lieu-dit',
      code_departement_plan: departmentCode || '',
      code_region_plan: regionCode || '',
      pays: countryCode
    }
  }

  if (route === ROUTE_SEO_DIRECTORY_LANDMARK) {
    const { subtype } = selectCurrentHistoryRouteParams(store)
    return {
      type: 'Page_annuaire_destination_touristique_avril_2025',
      localite_plan: `landmark:${subtype}`,
      pays: '250'
    }
  } else if (route === ROUTE_SEO_DIRECTORY_NAMED_PLACE) {
    return {
      type: 'Page_annuaire_destination_touristique_avril_2025',
      localite_plan: 'named_place',
      pays: '250'
    }
  } else if (route === ROUTE_SEO_DIRECTORY_SKI_RESORT) {
    return {
      type: 'Page_annuaire_stations_sports_hiver_avril_2025',
      localite_plan: 'station_sport_hiver',
      pays: '250'
    }
  } else if (route === ROUTE_SEO_DIRECTORY_SEASIDE_RESORT) {
    return {
      type: 'Page_annuaire_stations_balneaires_juin_2025',
      localite_plan: 'station_balneaire',
      pays: '250'
    }
  }

  const firstPoi =
    selectCurrentGeoentity(store) ?? selectFirstGeoentitySatisfying(store, { keys: ['towncode', 'countryCode'] })
  const location = !isEmpty(firstAddress) ? firstAddress : firstPoi

  if (!location) return

  const geoentityMoreData = isAGeoentityRoute(route)
    ? {
        code_postal_depart: firstPoi.postcode,
        note_poi: `${getPoiAverageNote(firstPoi)}/${getPoiMaxNote(firstPoi)}`,
        avis_poi: getPoiNumberOfReviews(firstPoi),
        id_poi: firstPoi.id
      }
    : {}

  return {
    ...getRedirection(query),
    stc_codealler: `${location.towncode || ''}/${location.countryCode || ''}`,
    ...geoentityMoreData,
    ...(pageTag?.tag_id ? { tag_id: pageTag?.tag_id } : {})
  }
}

const f3Resolver = (store, pageTag) => {
  switch (pageTag.name) {
    case 'ReponseItineraire':
    case 'ReponseItineraireChoix':
      return selectStopSteps(store)?.length > 0 ? 1 : 0
  }
  return ''
}

const x3Resolver = store => {
  if (selectIsASearchPage(store) || selectIsASearchOnItineraryPage(store)) {
    const { category, subcategory, app } = selectSearchParameters(store)
    if (subcategory) {
      const cat = findCategoryForItem(store, { id: subcategory, type: CONFIG_TYPES.subcategory })
      return cat?.id ?? ''
    }
    if (app) {
      const catId = findCategoryIdForApp(app)(store)
      return catId ?? ''
    }
    return category || ''
  }
  return ''
}

const x4Resolver = store => {
  const currentRoute = selectCurrentHistoryRoute(store)
  if (isSearchOnItineraryRoute(currentRoute)) return getPoiRubricId(selectFirstGeoentity(store)) ?? ''
  if (isGeoentityOnItineraryRoute(currentRoute)) return selectCurrentGeoentityRubricId(store) ?? ''
  if (selectIsItineraryUniverse(store)) return getPoiRubricId(selectArrivalStep(store)) ?? ''
  if (selectIsSearchPage(store)) {
    const { rubric } = selectSearchParameters(store)
    return rubric ?? ''
  }
  if (selectIsSeoCityActivityPage(store)) return selectGeoentityTypeDataForSearch(store)?.appOrRubricIds ?? ''
  return selectCurrentGeoentityRubricId(store) ?? ''
}

const x5Resolver = store => {
  if (!selectIsPlacesUniverse(store)) return ''
  if (selectIsSearchPage(store)) {
    const { app } = selectSearchParameters(store)
    return app || ''
  }
  if (selectIsSeoCityAppPage(store)) return selectGeoentityTypeDataForSearch(store)?.appOrRubricIds ?? ''
  const geoentity = selectCurrentGeoentity(store)
  if (geoentity) return geoentity?.currentTabId ?? 'NC'
  return 'all'
}

// return length value in Km with 1 decimal
const x6Resolver = store => {
  if (selectIsToolsComputeRadiusPage(store)) {
    return (parseFloat(selectComputeRadius(store)) / 1000).toFixed(0)
  }

  const oLength = selectCurrentItineraryRouteDistance(store)

  if (!oLength) return
  if (oLength.unit === 'km') return parseFloat(oLength.value)
  if (oLength.unit === 'm') return parseFloat((oLength.value / 1000).toFixed(1))
}

const x7Resolver = store => {
  const currentProvider = store.itinerary?.currentProvider
  const currentMode = selectCurrentMode(store)
  return `${currentMode}${currentProvider ? `_${currentProvider}` : ''}`
}

const x11Resolver = store => {
  if (selectIsItineraryUniverse(store)) {
    return selectDepartureStep(store)?.postcode
  }
  const firstAddress = selectFirstAddress(store)
  const firstPoi = selectFirstGeoentitySatisfying(store, { keys: ['postcode'] })
  const location = !isEmpty(firstAddress) ? firstAddress : firstPoi
  return location?.postcode
}

const x13Resolver = store => selectArrivalStep(store)?.postcode

const nameResolver = (store, pageTag) => {
  let pageName = pageTag.name

  if (pageName.includes('#Region')) {
    const { regionCode } = selectFirstAddress(store)
    pageName = pageName.replace('#Region', regionCode)
  }
  if (pageName.includes('#Department')) {
    const { departmentCode } = selectFirstAddress(store)
    pageName = pageName.replace('#Department', departmentCode)
  }

  return pageName
}

const mvResolver = (store, pageTag) => {
  const variantList = selectVariantForAbTestId(store, { id: 'hotel-cta-liste' })
  const variantCard = selectVariantForAbTestId(store, { id: 'hotel-cta-fiche' })

  if (!variantCard && !variantList) return {}

  switch (pageTag.tag_id) {
    case PAGE_TAG.PAGE_RESPONSE_CATEGORY_MAP.tag_id:
      return {
        mv_test: 'cta_hotel',
        mv_creation: variantList.id
      }
    case PAGE_TAG.PAGE_FICHE_POI.tag_id:
      return {
        mv_test: 'cta_hotel',
        mv_creation: variantCard.id
      }
  }
}

export default {
  [PAGE_PARAM_NAME]: nameResolver,
  [PAGE_PARAM_STC]: stcResolver,
  [PAGE_PARAM_X3]: x3Resolver,
  [PAGE_PARAM_X4]: x4Resolver,
  [PAGE_PARAM_X5]: x5Resolver,
  [PAGE_PARAM_X6]: x6Resolver, // valeur numérique : longueur de l'itinéraire, taille du rayon
  [PAGE_PARAM_X7]: x7Resolver,
  [PAGE_PARAM_X9]: store => `${selectHasRoadbook(store) ? 'avec' : 'sans'}_feuillederoute`,
  [PAGE_PARAM_X10]: store => selectFirstGeoentitySatisfying(store, { keys: ['regionCode'] })?.regionCode ?? '',
  [PAGE_PARAM_X11]: x11Resolver, // code postal du départ, de l'adresse ou du poi
  [PAGE_PARAM_X13]: x13Resolver, // code postal de l'arrivée
  [PAGE_PARAM_X15]: store =>
    selectDepartureStep(store)?.from === SUGGEST_FROM_VALUES.history ? 'POI|historique' : 'adresse|na',
  [PAGE_PARAM_X17]: store =>
    selectArrivalStep(store)?.from === SUGGEST_FROM_VALUES.history ? 'POI|historique' : 'adresse|na',
  [PAGE_PARAM_F3]: f3Resolver,
  [PAGE_PARAM_MV]: mvResolver
}
